import { useEffect, useState } from "react";
import { Table, Button, Popconfirm } from "antd";
import {
  getAll,
  addKorisnik,
  promijeniLozinkuAdmin,
  deaktiviraj,
  aktiviraj,
} from "../../services/korisnik.service";
import AddEmployeeModal from "../../components/AddEmployeeModal";
import EditEmployeeModal from "../../components/EditEmployeeModal";
import LozinkaModal from "../../components/LozinkaModal";
import "./KorisnickiNaloziPage.css";
const KorisnickiNaloziPage = () => {
  const [korisnici, setKorisnici] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [lozinkaModalOpen, setLozinkaModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const fetchUsers = async () => {
    try {
      const res = await getAll();
      setKorisnici(res.data);
    } catch (err) {
      alert("Greška pri dohvatanju korisnika");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  const handleCreate = async (values) => {
    try {
      const payload = {
        ...values,
        tip_korisnika: "ZAPOSLENI",
        role: "ZAPOSLENI",
      };
      await addKorisnik(payload);
      alert("Korisnik je uspjesno kreiran");
      setModalOpen(false);
      fetchUsers();
    } catch (err) {
      alert("Greška prilikom kreiranja korisnika");
    }
  };

  const handleLozinkaChange = async (values) => {
    try {
      const payload = { ...values, lozinka: "ZAPOSLENI" };
      await promijeniLozinkuAdmin(payload);
      alert("Lozinka je uspjesno promijenjena");
      setLozinkaModalOpen(false);
      fetchUsers();
    } catch (err) {
      alert("Greška prilikom promjene lozinke");
    }
  };

  const handleDelete = async (korisnik) => {
      if (korisnik.role === "ADMIN" || korisnik.tipKorisnika === "ADMIN") {
    alert("Administrator se ne može deaktivirati.");
    return;
  }
    try {
      await deaktiviraj(korisnik.korisnickoIme);
      alert("Korisnik obrisan.");
      fetchUsers();
    } catch (err) {
      alert("Greška pri deaktiviranju korisnika.");
    }
  };

  const handleAktiviraj = async (korisnik) => {
    try {
      await aktiviraj(korisnik.korisnickoIme);
      alert("Korisnik je uspješno aktiviran.");
      fetchUsers();
    } catch (err) {
      if (err.response?.status === 400) {
        alert("Korisnik je već aktiviran.");
      } else {
        alert("Greška pri aktiviranju korisnika.");
      }
    }
  };

  const columns = [
    { title: "Ime", dataIndex: "ime", key: "ime" },
    { title: "Prezime", dataIndex: "prezime", key: "prezime" },
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Korisničko ime",
      dataIndex: "korisnickoIme",
      key: "korisnickoIme",
    },
    { title: "Uloga", dataIndex: "role", key: "role" },

    {
      title: "Akcije",
      key: "akcije",
      render: (_, record) => {
        const isActive = record.aktivan === true;
        return (
          <>
            <Button
              type="link"
              onClick={() => {
                setSelectedUser(record);
                setEditModalOpen(true);
              }}
            >
              Ažuriraj
            </Button>

            {isActive ? (
              <Popconfirm
                title="Da li ste sigurni da želite deaktivirati ovog korisnika?"
                onConfirm={() => handleDelete(record)}
                okText="Da"
                cancelText="Ne"
              >
                <Button type="link" danger>
                  Deaktiviraj
                </Button>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="Da li ste sigurni da želite aktivirati ovog korisnika?"
                onConfirm={() => handleAktiviraj(record)}
                okText="Da"
                cancelText="Ne"
              >
                <Button type="link" style={{ color: "blue" }}>
                  Aktiviraj
                </Button>
              </Popconfirm>
            )}

            <Button
              style={{ color: "green" }}
              type="link"
              onClick={() => {
                setSelectedUser(record);
                setLozinkaModalOpen(true);
              }}
            >
              Lozinka
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <div>
      <div className="korisnickinalozipage-div">
        <Button type="primary" onClick={() => setModalOpen(true)}>
          Dodaj nalog
        </Button>
      </div>
      <div className="korisnickinalozipage-table">
        <div className="responsive-table-wraper">
          <Table
            dataSource={korisnici}
            columns={columns}
            rowKey="korisnicko_ime"
            scroll={{ x: true }}
          />

          <AddEmployeeModal
            open={modalOpen}
            onCancel={() => setModalOpen(false)}
            onCreate={handleCreate}
          />
          <EditEmployeeModal
            open={editModalOpen}
            onCancel={() => {
              setEditModalOpen(false);
              setSelectedUser(null);
            }}
            initialValues={selectedUser}
            onUpdated={() => {
              fetchUsers();
              setEditModalOpen(false);
              setSelectedUser(null);
            }}
          />
          <LozinkaModal
            open={lozinkaModalOpen}
            onCancel={() => {
              setLozinkaModalOpen(false);
              setSelectedUser(null);
            }}
            onCreate={handleLozinkaChange}
            korisnickoIme={selectedUser?.korisnickoIme}
            ime={selectedUser?.ime}
            prezime={selectedUser?.prezime}
            staraLozinka={selectedUser?.lozinka}
          />
        </div>
      </div>
    </div>
  );
};

export default KorisnickiNaloziPage;
